// extracted by mini-css-extract-plugin
module.exports = {"image_container":"HeaderLogo_image_container__LI23X"};